import { orderedOnboardingSteps } from '../../Onboarding/helpers/onboardingSteps'

const signUpUrl = '/candidate/signup'
const onboardingUrlParts = [...orderedOnboardingSteps, 'confirm-details']
const onboardedUrlParts = [
  'interview_requests',
  'dashboard',
  'job-search',
  'personal-information',
  'preferred-salary',
  'ideal-job',
  'work-authorisation',
  'preferred-location',
  'online-profiles',
  'preferred-roles',
  'top-skills',
  'work-history',
  'education',
  'about-me',
  'projects',
  'uploaded-files',
  'blocked-companies',
]

// Filter out paths with the same name in onboarded views
const onboardingOnlyUrlParts = onboardingUrlParts.filter(part => !onboardedUrlParts.includes(part))

const onboardingOnlyUrlPathnames = candidateId => [
  ...onboardingOnlyUrlParts.map(part => `/candidate/${candidateId}/${part}`),
  // temporary redirects: remove after 01/09/2022
  ...onboardingUrlParts.map(part => `/candidate/${part}`),
  signUpUrl,
]

export const isOnboardingOnlyRoute = (candidateId, currentPathname) =>
  onboardingOnlyUrlPathnames(candidateId).some(name => currentPathname.includes(name))

const unprotectedRoutes = [signUpUrl, '/candidate/social-auth', '/']
export const isProtectedRoute = currentPathname => {
  return !unprotectedRoutes.includes(currentPathname)
}
